import axios from 'axios'
import {  Message, Loading } from 'element-ui'
import { removeToken } from '@/utils/auth'
import store from '../store'
import { getToken } from '@/utils/auth'
import router from '../router/index'

let loadingInstance ;
// 创建axios实例
// 所有的请求发向9000端口（9000端口是后台gateway模块所占用的端口）
const service = axios.create({
  baseURL: 'http://111.47.28.118:9100',
  // baseURL: 'http://47.99.240.74:19001',
  // baseURL: 'http://localhost:9000',
  timeout: 20000 // 请求超时时间AA
})

// request拦截器
service.interceptors.request.use(
  config => {
    // if (store.getters.token) {
      // config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['Authorization'] = getToken() ? "Bearer "+getToken() : '' // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    loadingInstance = Loading.service({ fullscreen: true });
    return config;
  },
  error => {
    // this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
      loadingInstance.close();
    // });
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非20000是抛错 可结合自己业务进行修改
     */
    //  this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
      loadingInstance.close();
    // });
    const res = response.data
    if (res.code !== 20000) {
      Message({
        message: res.msg,
        type: 'error',
        duration: 5 * 1000
      })
      // if(res.code === 403){
      //   Message({
      //     message:'权限不够',
      //     type:'error',
      //     duration: 5*1000
      //   })
      // }
    //   if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
    //     MessageBox.confirm(
    //       '你已被登出，可以取消继续留在该页面，或者重新登录',
    //       '确定登出',
    //       {
    //         confirmButtonText: '重新登录',
    //         cancelButtonText: '取消',
    //         type: 'warning'
    //       }
    //     ).then(() => {
    //       store.dispatch('FedLogOut').then(() => {
    //         location.reload() // 为了重新实例化vue-router对象 避免bug
    //       })
    //     })
    //   }
      return Promise.reject('error')
    } else {
      // this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
        loadingInstance.close();
      // });
      return response.data
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error,
      type: 'error',
      duration: 5 * 1000
    })
        removeToken()
        store.dispatch("setDataEmpty")
        store.state.routes = []
        // location.reload()
        router.replace('/index')
    // this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
      loadingInstance.close();
    // });

    return Promise.reject(error)
  }
)

export default service

export const getRequest = (url,params) => {
  return service({
    method:'get',
    url:`${url}`,
    data:params
  })
}